import React from "react"
import { createRoot } from 'react-dom/client';
import { Provider } from "react-redux"

import Component from "../components/auth"

import { combineReducers, createStore } from "redux";

import { default as loginStore } from '@/src/reducers/login';

const store = createStore(combineReducers({ login: loginStore }));

const app = document.getElementById("root");
const root = createRoot(app);
root.render(
    <Provider store={store}>
        <div>
            <Component />
        </div>
    </Provider>,
);